function createPowerTitle(t) {
    const powers = [];
    if (t === 's'){
      for (let i = 6; i >= -12; i = i - 0.25){
        powers.push(`${i > 0 ? '+' : ''}${i.toFixed(2)}`);
      }
    } else {
      for (let i = -2.25; i >= -4; i = i - 0.25){
        powers.push(`${i.toFixed(2)}`);
      }
      for (let i = 0; i >= -2; i = i - 0.25){
        powers.push(`${i.toFixed(2)}`);
      }
    }
    return powers;
  }

const dataFormat = {
    sphere: createPowerTitle('s'),
    cylinder: createPowerTitle('c'),
    count: ["6", "7", "8", "9", "10", "1", "2", "3", "4", "5"]
};

export function nextValue(val, type, index = 0) {
    const values = dataFormat[type];
    const indexVal = values.findIndex(i => i === val);
    if(index < 0){
        if(indexVal < Math.abs(index)) {
            return values[values.length + (index + indexVal)];
        }
    } else if(index > 0) {
        if(indexVal > values.length -1 - index) {
            index -= values.length - indexVal;
            return values[index];
        }
    }
    return values[indexVal + index];
}

export function nextDate(val, index = 0) {
    const values = dataFormat["sphere"];
    const valIndex = values.findIndex(i => i === val);
    return values[valIndex + index]
}
